import type { DomainEntity } from '@web-config-app/core';
import { getConfigEntityWithDomainEntitySchema } from '@web-config-app/core';
import { useConfigApp } from '../use-config-app/use-config-app';

/**
 * Wraps a domain entity into a `ConfigEntity` whose `schema` is the global config-entity
 * envelope schema with the domain entity's attributes spliced into the `domainEntityAttributes`
 * slot. Used by form rendering to get one schema covering both the envelope shape (entityMetadata,
 * etc.) and the domain-specific fields.
 * @returns {@link ConfigEntity}
 */

export const useConfigEntity = ({
  domainEntity,
  includeRelationships = false,
}: {
  domainEntity: DomainEntity;
  includeRelationships?: boolean;
}) => {
  const { configEntity } = useConfigApp();

  return getConfigEntityWithDomainEntitySchema(
    configEntity,
    domainEntity,
    includeRelationships,
  );
};
